export const getParamsMap = (params = {}) => {
  if (params === null) {
    params = {};
  }
  const keys = Object.keys(params);

  const paramsMap = new Map();
  for (const pair of keys) {
    paramsMap.set(pair, params[pair]);
  }

  return paramsMap;
};

export const buildPath = (path, paramsMap) =>
  path.replace(/:([\w\d]+)/g, (_, paramName) => {
    if (!paramsMap.has(paramName)) {
      throw new Error(
        `could not build path ("${path}") - param "${paramName}" does not exist`
      );
    }

    const response = paramsMap.get(paramName);

    paramsMap.delete(paramName);

    return response;
  });
